// Function to extract sections (nested items) from the DOM
function extractSections(element, currentLevel = 2) {
  return Array.from(element.querySelectorAll(":scope > sec")).flatMap(
    (section) => {
      const key = section.getAttribute("key") || "";
      const title1 = section.querySelector(":scope > title1");
      const titleText = title1?.textContent.trim() || "";

      const current = {
        key,
        title: titleText,
        level: `level${currentLevel}`,
        movable: true,
      };

      const nested = extractSections(section, currentLevel + 1);
      return [current, ...nested];
    }
  );
}

// Function to truncate text to a certain number of words
function truncateByWords(text, charLimit = 60) {
  if (!text) return "";
  if (text.length <= charLimit) return text;
  return text.slice(0, charLimit) + "…";
}

function getLevelNumber(levelStr) {
  return parseInt(levelStr.replace("level", ""), 10);
}

const handleDomChange = (sdata, desti, position, dom, editor) => {
  if (!editor) return;

  editor.undoManager.transact(() => {
    const source = dom.querySelector(`[key="${sdata.key}"]`);
    const destination = dom.querySelector(`[key="${desti.key}"]`);

    if (position > 0) {
      if (getLevelNumber(sdata.level) === getLevelNumber(desti.level)) {
        const allSiblings = Array.from(destination.children);
        const startIndex = allSiblings.findIndex(
          (el) => el.tagName.toLowerCase() === "sec"
        );
        let tagsToMove;
        if (startIndex > 0) {
          tagsToMove = allSiblings.slice(startIndex);
        } else {
          tagsToMove = allSiblings.slice(allSiblings.length);
        }

        tagsToMove.forEach((tag) => source.appendChild(tag));

        destination.parentNode.insertBefore(source, destination.nextSibling);
      } else if (getLevelNumber(sdata.level) > getLevelNumber(desti.level)) {
        const firstSec = Array.from(destination.children).find(
          (child) => child.tagName.toLowerCase() === "sec"
        );

        if (firstSec) {
          destination.insertBefore(source, firstSec);
        } else {
          destination.appendChild(source);
        }
      } else {
        const parent = destination.parentNode;
        const allSiblings = Array.from(parent.children);
        const startIndex = allSiblings.indexOf(destination);

        const tagsToMove = allSiblings.slice(startIndex + 1);

        tagsToMove.forEach((tag) => source.appendChild(tag));

        if (parent.parentNode) {
          parent.parentNode.insertBefore(source, parent.nextSibling);
        }
      }
    } else if (position < 0) {
      if (getLevelNumber(sdata.level) === getLevelNumber(desti.level)) {
        destination.parentNode.insertBefore(source, destination);
      } else if (getLevelNumber(sdata.level) < getLevelNumber(desti.level)) {
        const parent = destination.parentNode;
        const allSiblings = Array.from(parent.children);
        const startIndex = allSiblings.indexOf(destination);
        const tagsToMove = allSiblings.slice(startIndex);

        tagsToMove.forEach((tag) => source.appendChild(tag));

        if (parent.parentNode) {
          parent.parentNode.insertBefore(source, parent.nextSibling);
        }
      } else {
        const prev = destination.previousSibling;
        let firstSec = null;

        if (prev && prev.children) {
          firstSec = Array.from(prev.children).find(
            (child) => child.tagName.toLowerCase() === "sec"
          );
        }

        if (firstSec) {
          prev.insertBefore(source, firstSec);
        } else {
          prev.appendChild(source);
        }
      }
    }

    editor.undoManager.transact(() => {
      reorderFlatSecArray(dom);
    });
  });
};

function reorderFlatSecArray(dom) {
  const secArray = Array.from(dom.querySelectorAll("sec"));
  const topLevelSecs = secArray.filter(
    (sec) => !sec.parentElement.closest("sec")
  );

  // Map to store oldId -> newId
  const idMap = new Map();

  function processSections(secs, prefix = "", labelPrefix = "") {
    secs.forEach((sec, index) => {
      const order = index + 1;

      const newId = prefix ? `${prefix}_${order}` : `${order}`;
      const newLabel = labelPrefix ? `${labelPrefix}.${order}` : `${order}`;

      const oldId = sec.id; // store old id before changing
      sec.id = `s${newId}`;

      // store mapping
      idMap.set(oldId, sec.id);

      // Update label
      const label = sec.querySelector("label");
      if (label) label.innerText = newLabel;

      // Process nested sections
      const nestedSecs = secArray.filter((s) => s.parentElement === sec);
      if (nestedSecs.length > 0) {
        processSections(nestedSecs, newId, newLabel);
      }
    });
  }

  processSections(topLevelSecs);

  // Update all xref elements that reference the old ids
  const xrefs = Array.from(dom.querySelectorAll("xref"));
  xrefs.forEach((xref) => {
    const href = xref.getAttribute("href") || "";
    const rid = xref.getAttribute("rid") || "";
    const dataHref = xref.getAttribute("data-mce-href") || "";

    const oldId = (href || rid || dataHref).replace(/^#/, "");

    if (idMap.has(oldId)) {
      const newId = idMap.get(oldId);
      const value = convertIdToSuperscript(newId);
      xref.setAttribute("href", `#${newId}`);
      xref.setAttribute("rid", newId);
      xref.setAttribute("data-mce-href", `#${newId}`);
      xref.innerText = ` S${value} `;
    }
  });
}
function convertIdToSuperscript(idValue) {
  const superscriptMap = {
    0: "⁰",
    1: "¹",
    2: "²",
    3: "³",
    4: "⁴",
    5: "⁵",
    6: "⁶",
    7: "⁷",
    8: "⁸",
    9: "⁹",
  };

  const parts = idValue.split("_");

  const baseNum = parts[0].replace(/\D/g, "");

  let superscript = "";
  if (parts.length > 1) {
    superscript = parts
      .slice(1)
      .map((part) =>
        part
          .split("")
          .map((char) => superscriptMap[char] || char)
          .join("")
      )
      .join("");
  }

  return `${baseNum}${superscript}`;
}

export {
  handleDomChange,
  reorderFlatSecArray,
  extractSections,
  getLevelNumber,
  truncateByWords,
  convertIdToSuperscript,
};
